<app-header></app-header>
<div class="responsive">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-3">
        <app-sidebar></app-sidebar>
      </div>
      <div class="col-md-6">
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
          <div class="main-box">
            <div class="header margin-b" style="font-size: 16px">
              <div style="display: flex; justify-content: space-between">
                Campus Greeting
                <div
                  class="custom-control custom-switch"
                  style="
                    width: 400px;
                    display: flex;
                    align-items: center;
                    justify-content: end;
                  "
                >
                  <span style="margin-right: 45px;">{{
                    form.get("iswelcomeMessage")?.value ? "Enabled" : "Disabled"
                  }}</span>
                  <div style="display: flex; align-items: center; gap: 8px">
                    <input
                      type="checkbox"
                      formControlName="iswelcomeMessage"
                      (change)="isWelcomeMessage($event)"
                      class="custom-control-input"
                      id="customSwitch1"
                    />
                    <label
                    class="custom-control-label"
                    for="customSwitch1"
                    style="margin-top: -23px;"
                    ></label>
                  </div>
                  <p
                    *ngIf="form.get('iswelcomeMessage')?.value"
                    style="margin: 0; position: absolute; margin-top: 40px;"
                  >
                    (Disable to modify)
                  </p>
                </div>
              </div>
            </div>

            <div class="form-group">
              <textarea
                class="form-control"
                formControlName="welcomeMessages"
                rows="5"
                [(ngModel)]="greetingTitle"
                id="comment"
              ></textarea>

              <div style="text-align: right">
                <p style="margin-bottom: -1rem" class="small">
                  {{ greetingTitle.length || 0 }}/100
                </p>
              </div>
            </div>

            <div class="timeline-box">
              <div class="header">
                <div>Set Radius (meter)</div>
              </div>

              <div class="form-group range-wrap">
                <input
                  type="range"
                  formControlName="radius"
                  class="custom-range"
                  min="117"
                  max="1000"
                  step="5"
                  id="ex6"
                  (change)="setRange()"
                />
                <output class="bubble"></output>
              </div>
            </div>

            <div>
              <div
                formArrayName="days"
                *ngFor="let item of form.get('days')['controls']; let i = index"
              >
                <div [formGroupName]="i">
                  <div class="body-card">
                    <div class="card margin-b">
                      <div
                        class="card-header header-style main-backgroundcolor"
                      >
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input margin-t"
                            formControlName="isDaysSelected"
                            (change)="onChange($event, 'days')"
                            type="checkbox"
                            id="inlineCheckbox1"
                          />
                          <label
                            class="form-check-label margin-l"
                            for="inlineCheckbox1"
                            >{{ item.get("dayName").value }}</label
                          >
                        </div>
                      </div>
                      <div class="card-body">
                        <div
                          class="form-check form-check-inline margin-b"
                          style="margin-left: 4px"
                        >
                          <input
                            class="form-check-input margin-t"
                            (change)="onChange($event, 'hours', i)"
                            formControlName="is24Hours"
                            type="checkbox"
                            id="inlineCheckbox1"
                          />
                          <label
                            class="form-check-label"
                            style="font-size: 24px; margin-left: 20px"
                            for="inlineCheckbox1"
                          >
                            24 Hours</label
                          >
                        </div>

                        <div class="time-picker">
                          <div class="form-row">
                            <div class="col">
                              <label>Start Time</label>
                              <timepicker
                                [appDisableDir]="arr[i].is24Hours"
                                formControlName="StartTime"
                              >
                              </timepicker>
                            </div>
                            <div class="col">
                              <label>End Time</label>

                              <timepicker
                                [appDisableDir]="arr[i].is24Hours"
                                formControlName="EndTime"
                              >
                              </timepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <button
                  type="submit"
                  class="btn btn-lg btn-block main-backgroundcolor"
                >
                  Save/Update
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="col-md-3">
        <app-events [showheader]="true"></app-events>
      </div>
    </div>
  </div>
</div>
